const fetchDataWithHeaders = async (url, method, headers, body) => {
  var options = {
    method,
    headers,
  };
  if (method === "POST") {
    options = {
      ...options,
      body: JSON.stringify(body || {}),
    };
  }
  const response = await fetch(url, options);
  const data = await response.json();
  return data;
};

const headers = {
  "Content-Type": "application/json",
};

const makeFetch = async ({ url, method, body }) => {
  try {
    const authorizationToken = JSON.parse(
      localStorage.getItem("authorizationToken")
    );
    const headersToUser = {
      ...headers,
      Authorization: `Bearer ${authorizationToken}`,
    };
    return await fetchDataWithHeaders(
      `/api/v1/${url}`,
      method,
      headersToUser,
      body
    );
  } catch (error) {
    return undefined;
  }
};
export { makeFetch };
